import { translate } from '@vimeo/i18n-runtime';

export const AUDIO_TRACKS_TYPES: {
  [key: string]: string;
} = {
  main: translate('dubbed audio'),
  descriptive: translate('audio description'),
  commentary: translate('commentary'),
  ai_generated: translate('AI generated'),
};
